import React, { useEffect } from "react";
import { connect } from "react-redux";

import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";

import { RootState } from "@app/store/rootReducer";

import { destroyEntityEmails, initEntityEmails } from "../store/actions";
import { isEntityEmailsInitialized } from "../store/selectors";

import ChildEmailsModal from "./ChildEmailsModal";
import ParentEmails from "./ParentEmails";

interface ParentEmailsProps {
  entity: EntitiesSupportedByEmailFeature;
  initialized: boolean;
  onDestroy: typeof destroyEntityEmails;
  onInit: typeof initEntityEmails;
}

const EntityEmails: React.FC<ParentEmailsProps> = ({ entity, initialized, onDestroy, onInit }) => {
  useEffect(() => {
    onInit({ entity });

    return () => {
      onDestroy();
    };
  }, [entity, onInit, onDestroy]);

  if (!initialized) {
    return null;
  }

  return (
    <>
      <ParentEmails />
      <ChildEmailsModal />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  initialized: isEntityEmailsInitialized(state),
});

const mapDispatchToProps = {
  onDestroy: destroyEntityEmails,
  onInit: initEntityEmails,
};

export default connect(mapStateToProps, mapDispatchToProps)(EntityEmails);
